import { enumclass } from './enumclass'

export const BalanceTaskStatus = enumclass({
  INIT: 1000, // 准备就绪
  EXECUTE: 1100, // 开始执行
  EXECUTE_DONE: 1101, // 执行完成
  REVERT: 1200, // 开始撤销
  REVERT_DONE: 1201, // 撤销完成
})

export const BalanceTaskStatusNameMap = {
  [BalanceTaskStatus.INIT]: '准备就绪',
  [BalanceTaskStatus.EXECUTE]: '开始执行',
  [BalanceTaskStatus.EXECUTE_DONE]: '执行完成',
  [BalanceTaskStatus.REVERT]: '开始撤销',
  [BalanceTaskStatus.REVERT_DONE]: '撤销完成',
}

export function getBalanceTaskStatusName(value) {
  return BalanceTaskStatusNameMap[value] || value
}
